import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=655462f0&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=js&"
export * from "./PasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=655462f0&prod&lang=scss&scoped=true&"
import style1 from "./PasswordReset.vue?vue&type=style&index=1&id=655462f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655462f0",
  null
  
)

export default component.exports